<h2 mat-dialog-title>
    {{'export_menu_desc' | translate}}
</h2>

<mat-dialog-content class="dialog-content-pad-10">
    <h3 class="media-heading"><small>{{ 'export_email_will_be_send' | translate }}</small></h3>
    <div class="col-md-8 pt-2 mx-auto">
        <div class="media push mb-4 p-3">
            <div class="media-body">
                <h4 class="media-heading">{{'export_userlist_section_desc' | translate}}</h4>
                <div class="row">
                    <div class="col-md-8">
                        <p>{{'export_excel_description' | translate}}</p>
                    </div>
                    <div class="col-md-4">
                        <button class="btn btn-primary d-block w-100 mt-2 mt-md-0" (click)="exportTeamMembers()">
                            <i class="far fa-file-export"></i>
                            {{ 'export_download' | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="justify-content-center">
    <button type="button"
            class="btn btn-default"
            (click)="close()">{{'close' | translate}}</button>
</mat-dialog-actions>